import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader',
  imports: [],
  templateUrl: './loader.html',
  styleUrl: './loader.scss',
})
export class Loader {
  /** When true, renders as a fixed full-page overlay that greys out the screen */
  overlay = input(false);
  /** Spinner size: 'sm' (inline small), 'md' (section), 'lg' (full-page default) */
  size = input<'sm' | 'md' | 'lg'>('lg');
  /** Optional message displayed below the spinner */
  message = input<string>('');
}
